<template>
  <div class="Mlogin">
    <LoginControl></LoginControl>
  </div>
</template>

<script>
import LoginControl from '../components/LoginControl'
export default {
  components: { LoginControl },
}
</script>
